import './PeriscopeSource.scss';

import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { ArovyLogo } from './ArovyLogo';
import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import { ORGANIZATION_TYPE_LABELS } from '@sonar-software/sonar-ts-constants';
import { SalesforceLogo } from './SalesforceLogo';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { Tooltip } from 'antd';
import { useAmplitude } from '@hooks';

import React, { useCallback } from 'react';

const sourceIcons: Record<string, React.FC<{ color?: string; title?: string }>> = {
	[ ORGANIZATION_TYPE_LABELS.PARDOT ]: SalesforceLogo,
	[ ORGANIZATION_TYPE_LABELS.SALESFORCE ]: SalesforceLogo,
	[ ORGANIZATION_TYPE_LABELS.SONAR ]: ArovyLogo
};

export interface PeriscopeSourceProps {
	iconColor?: string;
	id?: string;
	sonarObjectType: SonarObjectType;
	url?: string;
}

export const PeriscopeSource: React.FC<PeriscopeSourceProps> = ({ iconColor, id, sonarObjectType, url }) => {
	const logAnalyticEvent = useAmplitude();

	const sourceLabel = getSonarObjectTypeSourceLabel(sonarObjectType);
	const Icon = sourceIcons[ sourceLabel ];

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLSpanElement>) => {
			e.stopPropagation();

			logAnalyticEvent({
				data: { objectType: sonarObjectType },
				id: AMPLITUDE_EVENT.SALESFORCE_URL_CLICKED
			});
		},
		[ logAnalyticEvent, sonarObjectType ]
	);

	const iconBase = <Icon
		color={ iconColor }
		title='' />;

	const iconDisplay = url ?
		<a
			href={ url }
			id={ id }
			onClick={ handleClick }
			target='_blank'
			title={ sourceLabel }>
			{ iconBase }
		</a>	 :
		iconBase;

	return (
		<div className='periscope-source'>
			<Tooltip
				placement='bottom'
				title={ sourceLabel }>
				{ iconDisplay }
			</Tooltip>
		</div>
	);
};
